import { Promise } from 'meteor/promise';
// Promise.all() for objects
Object.defineProperty(Promise, 'allKeys', {
  configurable: true,
  writable: true,
  value: async function allKeys(object) {
    const resolved = {};
    const promises = Object.entries(object).map(async ([key, promise]) => {
      resolved[key] = await promise;
    });
    await Promise.all(promises);
    return resolved;
  }
});
